"use client";
import {
  __async
} from "../chunk-M66XENHI.js";
import { setupWorker } from "../workers/workerWrapper.js";
function signTransaction(ctx, userId, walletId, share, tx, chainId, sessionCookie, isDKLS) {
  return __async(this, null, function* () {
    return new Promise((resolve, reject) => __async(this, null, function* () {
      let worker = null;
      worker = yield setupWorker(
        ctx,
        (sendTransactionRes) => __async(this, null, function* () {
          resolve(sendTransactionRes);
          worker == null ? void 0 : worker.terminate();
        }),
        (error) => {
          worker == null ? void 0 : worker.terminate();
          reject(error);
        }
      );
      worker.postMessage({
        env: ctx.env,
        apiKey: ctx.apiKey,
        cosmosPrefix: ctx.cosmosPrefix,
        params: { share, walletId, userId, tx, chainId },
        functionType: "SIGN_TRANSACTION",
        offloadMPCComputationURL: ctx.offloadMPCComputationURL,
        disableWorkers: ctx.disableWorkers,
        sessionCookie,
        useDKLS: isDKLS,
        disableWebSockets: ctx.disableWebSockets,
        wasmOverride: ctx.wasmOverride
      });
    }));
  });
}
function sendTransaction(ctx, userId, walletId, share, tx, chainId, sessionCookie, isDKLS) {
  return __async(this, null, function* () {
    return new Promise((resolve, reject) => __async(this, null, function* () {
      let worker = null;
      worker = yield setupWorker(
        ctx,
        (sendTransactionRes) => __async(this, null, function* () {
          resolve(sendTransactionRes);
          worker == null ? void 0 : worker.terminate();
        }),
        (error) => {
          worker == null ? void 0 : worker.terminate();
          reject(error);
        }
      );
      worker.postMessage({
        env: ctx.env,
        apiKey: ctx.apiKey,
        cosmosPrefix: ctx.cosmosPrefix,
        params: { share, walletId, userId, tx, chainId },
        functionType: "SEND_TRANSACTION",
        offloadMPCComputationURL: ctx.offloadMPCComputationURL,
        disableWorkers: ctx.disableWorkers,
        sessionCookie,
        useDKLS: isDKLS,
        disableWebSockets: ctx.disableWebSockets,
        wasmOverride: ctx.wasmOverride
      });
    }));
  });
}
function signMessage(ctx, userId, walletId, share, message, sessionCookie, isDKLS, cosmosSignDoc) {
  return __async(this, null, function* () {
    return new Promise((resolve, reject) => __async(this, null, function* () {
      let worker = null;
      worker = yield setupWorker(
        ctx,
        (signMessageRes) => __async(this, null, function* () {
          resolve(signMessageRes);
          worker == null ? void 0 : worker.terminate();
        }),
        (error) => {
          console.error(`Worker error in signMessage for userId ${userId}, walletId ${walletId}:`, error);
          worker == null ? void 0 : worker.terminate();
          reject(error);
        }
      );
      worker.postMessage({
        env: ctx.env,
        apiKey: ctx.apiKey,
        cosmosPrefix: ctx.cosmosPrefix,
        params: { share, walletId, userId, message, cosmosSignDoc },
        functionType: "SIGN_MESSAGE",
        offloadMPCComputationURL: ctx.offloadMPCComputationURL,
        disableWorkers: ctx.disableWorkers,
        sessionCookie,
        useDKLS: isDKLS,
        disableWebSockets: ctx.disableWebSockets,
        wasmOverride: ctx.wasmOverride
      });
    }));
  });
}
function ed25519Sign(ctx, userId, walletId, share, base64Bytes, sessionCookie) {
  return __async(this, null, function* () {
    return new Promise((resolve, reject) => __async(this, null, function* () {
      let worker = null;
      worker = yield setupWorker(
        ctx,
        (signMessageRes) => __async(this, null, function* () {
          resolve(signMessageRes);
          worker == null ? void 0 : worker.terminate();
        }),
        (error) => {
          console.error(`Worker error in ed25519Sign for userId ${userId}, walletId ${walletId}:`, error);
          worker == null ? void 0 : worker.terminate();
          reject(error);
        }
      );
      worker.postMessage({
        env: ctx.env,
        apiKey: ctx.apiKey,
        cosmosPrefix: ctx.cosmosPrefix,
        params: { share, walletId, userId, base64Bytes },
        functionType: "ED25519_SIGN",
        disableWorkers: ctx.disableWorkers,
        sessionCookie,
        disableWebSockets: ctx.disableWebSockets,
        wasmOverride: ctx.wasmOverride
      });
    }));
  });
}
export {
  ed25519Sign,
  sendTransaction,
  signMessage,
  signTransaction
};
